// extracted by mini-css-extract-plugin
export default {"cls1":"styles-cls1___7697c25aaad302bfb59","cls2":"styles-cls2___16b249ad2c7ab28e90b styles-cls1___7697c25aaad302bfb59"};